<template>
  <div>
    <vs-prompt
      :active.sync="showDialog"
      class="crew-prompt"
      buttons-hidden
      :title="dialogTitle || ''"
      :color="AISEA_COLOR.BLACK"
    >
      <div style="position: absolute; top: 10px; right: 10px">
        <feather-icon
          icon="XIcon"
          svg-classes="h-6 w-6"
          @click="showDialog = false"
        />
      </div>
      <div
        class="w-full mb-2"
        style="max-height: calc(100vh - 200px); overflow-y: auto"
      >
        <div
          class="crew-labor-period flex w-full justify-start"
          style="flex-direction: column"
        >
          <div ref="crewEditForm">
            <div class="mb-2 aisea-text-16-400-black">
              基準労働期間を選択してください。
            </div>
            <div style="overflow-y: scroll">
              <div
                class="work-period-list-item cursor-pointer"
                :class="{
                  'work-period-list-item--selected': isSelected(labor.id),
                }"
                v-for="(labor, index) in labors"
                :key="index"
                @click="selectWorkPeriod(labor)"
              >
                <span class="ml-2"
                  >{{ `${labor.work_period_from}〜${labor.work_period_to}` }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vs-divider style="margin: 0" />
      <div class="flex w-full justify-end items-center">
        <div class="m-3 mb-0">
          <vs-button
            type="border"
            style="width: 6rem; padding: 0.4rem"
            @click="onCancel"
            :color="AISEA_COLOR.GRAY"
            >キャンセル</vs-button
          >
        </div>
        <div class="m-3 mb-0">
          <vs-button
            :disabled="!validate"
            :color="AISEA_COLOR.BLUE"
            style="width: 6rem; padding: 0.4rem"
            @click="onSubmit()"
            >選択</vs-button
          >
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";

export default {
  mixins: [ColorMixin],
  name: "CrewLaborsEdit",
  components: {
  },
  props: {
    inputStandardWorkingPeriod: {
      Type: Function,
      required: false,
      default: () => { },
    },
    enterpriseCrewId: {
      Type: String,
      required: true
    },
    labors: {
      Type: Array,
      required: false,
      default: []
    },
  },
  data () {
    return {
      dialogTitle: "基準労働期間",
      selected: null,
      showDialog: false,
    };
  },
  computed: {
    validate () {
      return this.selected;
    },
  },
  methods: {
    selectWorkPeriod (item) {
      this.selected = item;
    },
    isSelected (id) {
      if (!this.selected) return false;
      return this.selected.id === id;
    },
    onCancel () {
      this.selected = null;
      this.$nextTick(() => {
        this.$emit('close');
      });
      this.close();
    },
    async onSubmit () {
      this.inputStandardWorkingPeriod(this.selected);
      this.selected = null;
      this.close();
    },
    async show () {
      this.showDialog = true;
    },
    close () {
      this.clean();
      this.$nextTick(() => {
        this.showDialog = false;
      });
    },
    clean () {
      this.selected = null;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";




.crew-prompt {
  .vs-dialog {
    width: 480px;
    min-height: calc(100vh - 40px - 40px) !important;

    .dialog-title {
      font-family: $aisea-font-family !important;
      font-size: 18px;
    }

    .vs-dialog-cancel {
      background-color: rgba(244, 244, 244, 0) !important;
      transform: none !important;
      box-shadow: none !important;
    }
  }
}

.crew-labor-period {
  .work-period-list-item {
    padding: 4px;
    font-size: 16px;
    font-family: $aisea-font-family;
    font-weight: 400;
    color: $aisea-dark-gray;
    border-radius: 4px;
    &:hover {
      background-color: $aisea-blue;
      color: $aisea-pure-white;
    }

    &--selected {
      background-color: $aisea-blue;
      color: $aisea-pure-white;
    }
  }
}
</style>